import React, { useEffect, useRef, useState } from "react";
import styles from "../../styles/winterpay.module.css";
import { ReactComponent as SymbolWhite } from "../../svg/sunbae-symbol-white.svg";

//윈터스쿨 셀프 결제 — 화면 조각 (디자인 결제링크 사전예약.dc.html 고객 화면)

export const cx = (...names: (string | false | null | undefined)[]) => names.filter(Boolean).join(" ");

/* ---------- 아이콘 ---------- */
const S = (p: { size?: number; stroke?: string; width?: number; style?: React.CSSProperties; children: React.ReactNode; fill?: string }) => (
    <svg width={p.size || 16} height={p.size || 16} viewBox="0 0 24 24" fill={p.fill || "none"} stroke={p.fill ? undefined : (p.stroke || "currentColor")} strokeWidth={p.width || 1.75} strokeLinecap="round" strokeLinejoin="round" style={p.style}>{p.children}</svg>
);
export const IconChevronDown = ({ size = 16, stroke = "#8B95A1" }: { size?: number; stroke?: string }) => <S size={size} stroke={stroke} width={1.4}><path d="m6 9 6 6 6-6" /></S>;
export const IconChevronRight = ({ size = 16, stroke = "currentColor", width = 1.75 }: { size?: number; stroke?: string; width?: number }) => <S size={size} stroke={stroke} width={width}><path d="m9 18 6-6-6-6" /></S>;
export const IconChevronLeft = () => <S size={18} stroke="#0A1931" width={1.5}><path d="m15 18-6-6 6-6" /></S>;
export const IconBack = () => <S size={24} stroke="#0A1931" width={1.75}><path d="m15 18-6-6 6-6" /></S>;
export const IconCheck = ({ size = 16, stroke = "currentColor", width = 2 }: { size?: number; stroke?: string; width?: number }) => <S size={size} stroke={stroke} width={width}><path d="M20 6 9 17l-5-5" /></S>;
export const IconX = ({ size = 14, width = 2.5 }: { size?: number; width?: number }) => <S size={size} width={width}><path d="M18 6 6 18" /><path d="m6 6 12 12" /></S>;
export const IconClock = () => <S size={16} fill="currentColor"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm1 5v4.59l3.2 3.2-1.41 1.42L11 12.41V7h2Z" /></S>;
export const IconInfo = () => <S size={16} fill="currentColor" style={{ flex: "none", marginTop: 3 }}><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm-1 5h2v7h-2V7Zm0 9h2v2h-2v-2Z" /></S>;
export const IconSeat = ({ size = 20 }: { size?: number }) => <S size={size}><path d="M5 11V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v5" /><path d="M3 11h18v4H3z" /><path d="M6 15v5" /><path d="M18 15v5" /></S>;
export const IconTag = () => <S size={20}><path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z" /><circle cx="7.5" cy="7.5" r="1" fill="currentColor" /></S>;
export const IconLock = ({ size = 20, stroke = "currentColor", style }: { size?: number; stroke?: string; style?: React.CSSProperties }) => <S size={size} stroke={stroke} style={style}><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></S>;
export const IconPerson = () => <S size={16} width={2} style={{ flex: "none" }}><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></S>;
export const IconCalendar = () => <S size={20} style={{ flex: "none" }}><rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" /></S>;
export const IconUpload = () => <S size={24} stroke="#0A1931"><path d="M12 16V4" /><path d="m6 10 6-6 6 6" /><path d="M4 20h16" /></S>;
export const IconZoom = () => <S size={16} width={2}><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5M11 8v6M8 11h6" /></S>;
export const IconRefresh = () => <S size={16} width={2}><path d="M3 12a9 9 0 0 1 15.5-6.2L21 8" /><path d="M21 3v5h-5" /><path d="M21 12a9 9 0 0 1-15.5 6.2L3 16" /><path d="M3 21v-5h5" /></S>;
export const IconPhone = () => <svg viewBox="0 0 24 24" width="100%" height="100%" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.81.36 1.6.7 2.34a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.74-1.27a2 2 0 0 1 2.11-.45c.74.34 1.53.57 2.34.7A2 2 0 0 1 22 16.92z" /></svg>;
export const IconKakao = () => <svg viewBox="0 0 24 24" width="100%" height="100%" fill="currentColor" aria-hidden="true"><path d="M12 4C7.03 4 3 7.13 3 10.99c0 2.42 1.62 4.55 4.06 5.77-.18.64-.65 2.36-.74 2.73-.12.46.17.45.35.33.14-.09 2.27-1.54 3.19-2.17.36.05.74.08 1.14.08 4.97 0 9-3.13 9-7C21 7.13 16.97 4 12 4z" /></svg>;

/* ---------- 초대장 카드 (사진 카드: 강동점 사진 + 연한 흐림 + 어둡게, 흰 심볼 로고) ---------- */
const INVITE_PHOTO = (process.env.PUBLIC_URL || "") + "/img/winterpay/invite-gangdong-12.webp";
/* 디자인 '결제링크 예약자' — 라벨 '윈터스쿨 정규 등록', 예약 링크면 우측에 No. 0031(예약 순번), 서브는 받는 사람 이름(없으면 개강일) */
export const InviteCard = ({ no, name }: { no?: number | null; name?: string | null }) => (
    <div className={styles.invite} data-invite="">
        <span aria-hidden="true" className={styles.inviteShadow} data-invite-shadow=""><span className={styles.inviteShadowIn} /></span>
        <span aria-hidden="true" className={styles.invitePhotoWrap}>
            <span className={styles.invitePhoto} data-invite-photo="" style={{ backgroundImage: `url(${INVITE_PHOTO})` }} />
            <span className={styles.invitePhotoDim} />
        </span>
        <span aria-hidden="true" className={styles.inviteEdge} />
        <div className={styles.inviteTop}>
            <span className={styles.inviteLabel}>윈터스쿨 정규 등록</span>
            {!!no && <span className={styles.inviteNo}>No. {String(no).padStart(4, "0")}</span>}
            <SymbolWhite className={styles.inviteLogo} aria-label="수능선배" data-invite-logo="" />
        </div>
        <div>
            <h1 className={styles.inviteTitle}>윈터스쿨 등록</h1>
            {name ? <p className={cx(styles.inviteSub, styles.inviteHolder)}>{name}</p> : <p className={styles.inviteSub}>11월 23일(월) 개강</p>}
        </div>
    </div>
);

/* ---------- 남은 시간 (1초 단위, 10분 미만은 1/100초 — rAF로 텍스트만 갱신) ---------- */
const pad2 = (n: number) => String(n).padStart(2, "0");
export const Countdown = ({ to }: { to: number }) => {
    const ref = useRef<HTMLSpanElement | null>(null);
    useEffect(() => {
        let raf = 0, last = "";
        const draw = () => {
            const ms = Math.max(0, to - Date.now()), sec = Math.floor(ms / 1000);
            const cs = sec < 600;
            const t = sec >= 3600 ? pad2(Math.floor(sec / 3600)) + ":" + pad2(Math.floor(sec % 3600 / 60)) + ":" + pad2(sec % 60)
                : pad2(Math.floor(sec / 60)) + ":" + pad2(sec % 60) + (cs ? "." + pad2(Math.floor(ms % 1000 / 10)) : "");
            if (t !== last && ref.current) { ref.current.textContent = t; ref.current.style.minWidth = cs ? "68px" : ""; last = t; }
            if (ms > 0) raf = requestAnimationFrame(draw);
        };
        draw();
        return () => cancelAnimationFrame(raf);
    }, [to]);
    return <span ref={ref} className={styles.remain} />;
};

/* ---------- 보는 중 · 결제 완료 (⚠ 가상 데이터 — 사용자 확정 2026-10-12) ----------
   보는 인원은 마운트 때 1~9 랜덤 고정, '○○○님 결제 완료'는 아래 50명(마스킹) 중 5초마다 랜덤. 실제 열람·결제와 무관 */
const VIEWER_PAID = [
    "김○준", "이○서", "박○윤", "최○우", "정○아", "강○민", "조○현", "윤○진", "장○희", "임○호",
    "한○수", "오○린", "서○영", "신○혁", "권○빈", "황○은", "안○율", "송○하", "전○훈", "홍○원",
    "유○나", "고○석", "문○경", "양○찬", "손○지", "배○원", "백○솔", "허○태", "남○연", "노○규",
    "하○람", "곽○주", "성○미", "차○건", "주○아", "우○재", "구○린", "민○성", "류○겸", "나○은",
    "진○혁", "지○유", "엄○준", "채○원", "원○호", "천○비", "방○호", "공○민", "현○서", "함○우",
];
const pickPaid = (prev: number) => { let i = Math.floor(Math.random() * VIEWER_PAID.length); if (i === prev) i = (i + 1) % VIEWER_PAID.length; return i; };
export const ViewersLine = () => {
    const [n] = useState(() => 1 + Math.floor(Math.random() * 9));
    const [pi, setPi] = useState(() => pickPaid(-1));
    useEffect(() => {
        const t = setInterval(() => { if (!document.hidden) setPi((p) => pickPaid(p)); }, 5000);
        return () => clearInterval(t);
    }, []);
    return (
        <span data-viewers="" role="status" aria-live="polite" className={styles.viewers}>
            <span className={styles.viewersL}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" className={styles.viewersEye}><path fillRule="evenodd" d="M12 5C5.5 5 2 12 2 12s3.5 7 10 7 10-7 10-7-3.5-7-10-7Zm0 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z" /><circle cx="12" cy="12" r="2" /></svg>
                <span>윈터스쿨 결제 화면을 <b>{n}명</b>이 보는 중</span>
            </span>
            <span><b>{VIEWER_PAID[pi]}</b>님 결제 완료</span>
        </span>
    );
};

/* ---------- 타이머 (디자인 '결제링크 예약자': '{마감 시각} 링크 마감까지 HH:MM:SS' + 보는 중 줄) ----------
   reserved = 예약 링크(/book) — 만료 문구가 '예약 순번이 사라졌어요' */
const RESERVED_EXPIRED = "1시간이 지나 예약 순번이 사라졌어요. 윈터스쿨 페이지에서 다시 신청하면 새 순번을 받아요";
export const TimerBar = ({ expired, to, dueMark, under10, variant, reserved }: { expired: boolean; to: number; dueMark: string; under10: boolean; variant: "pay" | "transfer"; reserved?: boolean }) => {
    const pre = (under10 ? "" : dueMark + " ") + "링크 마감까지";
    if (variant === "transfer") {
        return (
            <div data-pc-timer="" className={cx(styles.timer, styles.timerV, styles.timerVDone, expired && styles.timerExpired)}>
                <span className={styles.timerMain}>
                    <IconClock />
                    {expired ? <span className={styles.timerTail}>결제 링크가 만료되었어요</span> : <><span className={styles.timerPre}>{pre}</span><Countdown to={to} /></>}
                </span>
                <span className={styles.timerSub}>{expired ? (reserved ? "윈터스쿨 페이지에서 다시 신청하면 새 순번을 받아요" : "조기 마감 시 정규 예약은 오픈되지 않아요") : "등록은 입금 순서대로 확정돼요"}</span>
            </div>
        );
    }
    return (
        <div data-pc-timer="" className={cx(styles.timer, expired && styles.timerExpired)}>
            <span className={styles.timerMain}>
                <IconClock />
                {expired
                    ? <span className={styles.timerTail}>{reserved ? RESERVED_EXPIRED : "사전 예약 결제 기간이 끝났어요. 조기 마감 시 정규 예약은 오픈되지 않아요"}</span>
                    : <><span className={styles.timerPre}>{pre}</span><Countdown to={to} /></>}
            </span>
            {!expired && <ViewersLine />}
        </div>
    );
};

/* ---------- 모집 마감 팝업 (지점×프로그램 closed) — 디자인 cuWait ---------- */
export const WaitPop = ({ branchKo, progName, hasPre, onToPre, onOtherBranch, onWait }: { branchKo: string; progName: string; hasPre: boolean; onToPre: () => void; onOtherBranch: () => void; onWait: () => void }) => (
    <div role="dialog" aria-modal="true" aria-labelledby="wait-title" className={styles.waitWrap}>
        <div className={styles.waitDim} onClick={hasPre ? onToPre : onOtherBranch} />
        <div className={styles.waitCard}>
            <h3 id="wait-title" className={styles.waitTitle}>{branchKo} {progName}는{hasPre ? " 모집 마감," : ""}<br />{hasPre ? "프리윈터만 신청 가능해요" : "모집이 마감됐어요"}</h3>
            <p className={styles.waitP}>{hasPre ? `${progName}는 ` : ""}<b>대기</b>를 걸어두면 자리가 날 때 가장 먼저 연락드려요</p>
            <div className={styles.waitBadge}><span className={styles.waitBadgeName}><IconLock size={14} />{progName}</span><span className={styles.waitBadgeTag}>대기 신청만 가능</span></div>
            <div className={styles.waitBtns}>
                {hasPre
                    ? <button type="button" className={styles.waitPrimary} onClick={onToPre}>프리윈터 신청</button>
                    : <button type="button" className={styles.waitSecondary} onClick={onOtherBranch}>다른 지점</button>}
                <button type="button" className={styles.waitSecondary} onClick={onWait}>{progName} 대기신청</button>
            </div>
        </div>
    </div>
);

/* ---------- 상담 시트 ---------- */
export const ContactSheet = ({ isPay, onClose }: { isPay: boolean; onClose: () => void }) => (
    <div data-pc-sheet="" className={styles.sheetWrap}>
        <div className={styles.sheetBack} onClick={onClose} />
        <div data-exit-card="" className={styles.sheet}>
            <h3 className={styles.sheetTitle}>{isPay ? "결제 중" : "등록 관련"} 궁금한 점,<br />바로 물어보세요</h3>
            {isPay && <p className={styles.sheetP}>입력한 내용은 그대로 남아 있어요</p>}
            <div className={styles.sheetLinks}>
                <a href="tel:1668-5786" className={styles.sheetLink}>
                    <span className={styles.sheetIcon}><IconPhone /></span>
                    <span className={styles.sheetLinkText}><span className={styles.sheetLinkTitle}>전화로 상담하기</span><span className={styles.sheetLinkSub}>지금 바로 연결해 드려요</span></span>
                </a>
                <a href="https://pf.kakao.com/_Whxexgxj/chat" target="_blank" rel="noopener noreferrer" className={styles.sheetLink}>
                    <span className={styles.sheetIcon}><IconKakao /></span>
                    <span className={styles.sheetLinkText}><span className={styles.sheetLinkTitle}>카카오톡으로 상담하기</span><span className={styles.sheetLinkSub}>편한 시간에 답장 받으세요</span></span>
                </a>
            </div>
        </div>
    </div>
);

/* ---------- 드롭다운 / 세그먼트 ---------- */
export interface DdOption { value: string; label: string; }
export const Dropdown = ({ value, options, placeholder, open, onToggle, onPick }: { value: string; options: DdOption[]; placeholder: string; open: boolean; onToggle: () => void; onPick: (v: string) => void }) => {
    const cur = options.find(o => o.value === value);
    return (
        <div className={styles.dd} data-dd="">
            <button type="button" className={cx(styles.ddBtn, open && styles.ddBtnOpen, !cur && styles.ddPlaceholder)} aria-haspopup="listbox" aria-expanded={open} onClick={onToggle}>{cur ? cur.label : placeholder}</button>
            <span className={cx(styles.ddChev, open && styles.ddChevOpen)}><IconChevronDown /></span>
            {open && (
                <div role="listbox" className={styles.ddMenu}>
                    {options.map(o => (
                        <button type="button" role="option" aria-selected={o.value === value} key={o.value} className={cx(styles.ddOpt, o.value === value && styles.ddOptOn)} onClick={() => onPick(o.value)}>
                            <span>{o.label}</span>
                            <span style={{ visibility: o.value === value ? "visible" : "hidden", color: "#0A1931", display: "flex" }}><IconCheck width={1.75} /></span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export const SegGroup = ({ items, value, onChange }: { items: { value: string; label: string }[]; value: string; onChange: (v: string) => void }) => (
    <div role="radiogroup" className={styles.segGrid}>
        {items.map(it => <button type="button" role="radio" aria-checked={value === it.value} key={it.value} className={cx(styles.seg, value === it.value && styles.segOn)} onClick={() => onChange(it.value)}>{it.label}</button>)}
    </div>
);

/* ---------- 달력 (시작일) ---------- */
export interface CalCell { day: number | ""; empty: boolean; off: boolean; outside: boolean; sel: boolean; today: boolean; seat: boolean; onClick: (() => void) | null; }
export const Calendar = ({ title, cells, prevVis, nextVis, onPrev, onNext, seatLegend }: { title: string; cells: CalCell[]; prevVis: boolean; nextVis: boolean; onPrev: () => void; onNext: () => void; seatLegend: boolean }) => (
    <div className={styles.cal} data-cal="">
        <div className={styles.calHead}>
            <button type="button" aria-label="이전 달" className={cx(styles.calNav, !prevVis && styles.calNavHidden)} onClick={onPrev}><IconChevronLeft /></button>
            <span className={styles.calTitle}>{title}</span>
            <button type="button" aria-label="다음 달" className={cx(styles.calNav, !nextVis && styles.calNavHidden)} onClick={onNext}><span style={{ transform: "rotate(180deg)", display: "flex" }}><IconChevronLeft /></span></button>
        </div>
        {seatLegend && <div className={styles.calLegend}><span className={styles.calLegendDot} />표시된 날 입실하면 좌석을 직접 골라요</div>}
        <div className={styles.calWeek}>{["일", "월", "화", "수", "목", "금", "토"].map(w => <span key={w}>{w}</span>)}</div>
        <div className={styles.calGrid}>
            {cells.map((c, i) => (
                <div className={styles.calCell} key={i}>
                    <button type="button" disabled={c.empty || c.off || c.outside}
                        className={cx(styles.calDay, c.empty && styles.calDayEmpty, c.outside && styles.calDayOutside, !c.outside && c.off && styles.calDayOff, c.today && !c.sel && styles.calDayToday, c.sel && styles.calDaySel)}
                        onClick={c.onClick || undefined}>
                        {c.day}
                        <span aria-hidden="true" className={cx(styles.calSeatDot, c.sel && styles.calSeatDotSel)} style={{ visibility: c.seat ? "visible" : "hidden" }} />
                    </button>
                </div>
            ))}
        </div>
    </div>
);

/* ---------- 받는 혜택 카드 ---------- */
export interface Benefit { on: boolean; icon: "tag" | "seat" | "lock"; label: string; sub: string; }
export const BenefitCard = ({ b }: { b: Benefit }) => (
    <div className={cx(styles.bn, b.on ? styles.bnOn : styles.bnOff)} data-bn-on={b.on ? "1" : "0"}>
        <span className={styles.bnIcon}>{b.icon === "tag" ? <IconTag /> : b.icon === "seat" ? <IconSeat /> : <IconLock />}</span>
        <span className={styles.bnBody}>
            <span className={styles.bnHead}>
                <span className={styles.bnTitle}>{b.label}</span>
                {b.on ? <span className={styles.bnBadge}><IconCheck size={14} width={2.5} />적용</span> : <span className={styles.bnBadgeOff}><IconX />미적용</span>}
            </span>
            {b.sub && <span className={styles.bnSub}>{b.sub}</span>}
        </span>
    </div>
);

/* ---------- 완료 아이콘 (원이 커지며 체크가 그려짐) ---------- */
export const DoneIcon = () => (
    <span data-done-ico="" className={styles.doneIco}>
        <span data-done-fill="" className={styles.doneFill} />
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" className={styles.doneSvg}><path d="M4 12l5 5L20 6" stroke="#FFFFFF" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" className={styles.doneCheck} /></svg>
    </span>
);

/* ---------- 이체 내역 크게 보기 ---------- */
export const ProofZoom = ({ src, onClose }: { src: string; onClose: () => void }) => (
    <div role="dialog" aria-label="이체 내역 크게 보기" onClick={onClose} className={styles.zoomWrap}>
        <span role="img" aria-label="올린 이체 내역" className={styles.zoomImg} style={{ backgroundImage: `url(${src})` }} />
        <button type="button" onClick={onClose} aria-label="닫기" className={styles.zoomClose}><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round"><path d="M18 6 6 18M6 6l12 12" /></svg></button>
    </div>
);

/* ---------- 영수증 줄들 (등록비 / 할인 / 합계) ---------- */
export const DiscountRows = ({ orig, discLabel, discTxt, dashed }: { orig: string; discLabel: string; discTxt: string; dashed?: boolean }) => (
    <>
        <div className={styles.rcRow}><span className={styles.rcKey}>등록비</span><span className={styles.rcVal}>{orig}</span></div>
        <div className={styles.rcRow}><span className={styles.rcKey}>{discLabel}</span><span className={styles.rcDisc}>{discTxt}</span></div>
        <div role="separator" className={dashed ? styles.sepDashed : styles.sep} />
    </>
);

/* ---------- 등록 정보 줄 ---------- */
export const InfoRows = ({ rows }: { rows: [string, string][] }) => (
    <div className={styles.infoRows}>
        {rows.map(([k, v], i) => <div className={cx(styles.infoRow, i > 0 && styles.infoRowLine)} key={k}><span>{k}</span><span>{v}</span></div>)}
    </div>
);
